/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface ConditionEditorGroupSortableItemArgs {
  handle: string;
  item: any;
  groupName: string;
}

export default class ConditionEditorGroupSortableItem extends Component<ConditionEditorGroupSortableItemArgs> {
  get flyDragDropPluginOptions() {
    return {
      clone: {
        classes: ['cio-condition-editor-group-mirror'],
      },
    };
  }
}
